import Image from "components/Elements/Image/Image.tsx";
import UserBrandingCoverUploader from "../../UploadBrandingCover/UserBrandingCoverUploader.js";
import apiRequest from "utils/ApiRequest/apiRequest.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useModal } from "contexts/modalContext/modalContext.js";
import { useToasts } from "react-toast-notifications";
import { useUser } from "contexts/userContext/userContext.js";
import config from "config.ts";

const defaultBackground = `${config.api.resource}/assets/images/backgrounds/defaultGalleryBackgroundCover1.webp`;

const CoverImageUpload = ({ coverBackground, setCoverBackground }) => {
  const { setModal } = useModal();
  const { addToast } = useToasts();
  const { getTextByKey } = useContent();
  const { getUserData } = useUser();

  const disabledEditingByTopUser = getUserData().TopUserBrandingEnabled;

  const openCoverModal = () => {
    if (disabledEditingByTopUser) return;
    setModal({
      modal: UserBrandingCoverUploader,
      props: {
        setDefault: true,
        backgroundImage: coverBackground,
        setBackgroundImage: setCoverBackground,
        removeImageApi,
      },
    });
  };

  const removeImageApi = async () => {
    const response = await apiRequest(
      "UserTemplates",
      "DeleteBrandedCoverImageReact"
    );
    if (response.status === "success") {
      setCoverBackground(defaultBackground);
      addToast(getTextByKey("remove-cover-image-success"), {
        appearance: "success",
      });
    }
  };

  return (
    <div
      className={`cover-image-upload${
        disabledEditingByTopUser ? " not-enabled" : ""
      } `}
      onClick={() => openCoverModal()}
    >
      {!disabledEditingByTopUser ? (
        <>
          <span className="text-uplod-cover">
            {getTextByKey("change-cover-photo")}
          </span>
          <Image name="camera-transparent" ext="svg" />
        </>
      ) : (
        <span className="text-uplod-cover">
          {getTextByKey("brandign-not-enabled")}
        </span>
      )}
    </div>
  );
};

export default CoverImageUpload;
